import { handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import LocalStorageHelper from '../../utils/LocalStorageHelper';
import NotificationsType from '../types/NotificationsType';

import { GridFilters, initialStateList } from './GridFiltersReducer';

const initialState = {
  allNotifications: [],
  allNotificationsList: { ...initialStateList },
};

const dismissNotif = LocalStorageHelper.getData('dismissNotifications') || [];

export const Notifications = handleActions(
  {
    ...GridFilters,
    [NotificationsType.actions.fetchNotificationsSuccess]: (currentState, { payload }) => {
      return { ...currentState, allNotifications: payload };
    },
    [NotificationsType.actions.dismissNotification]: (currentState, { payload }) => {
      dismissNotif.push(payload);
      LocalStorageHelper.storeData('dismissNotifications', dismissNotif);
      return { ...currentState, allNotifications: currentState.allNotifications.filter(({ id }) => id !== payload) };
    },
  },
  initialState
);

const getNotifications = (state) => state.Notifications;

export const getNotificationsList = (state, list) => {
  const notifications = getNotifications(state);
  return notifications[list] || undefined;
};

export const getAllNotifications = createSelector(getNotifications, ({ allNotifications }) => allNotifications);
export const getActiveNotifications = createSelector(getAllNotifications, (allNotifications) => allNotifications.filter(({ id }) => dismissNotif.indexOf(id) === -1));
